require('./bootstrap');
require('./hamburger');
// require('./cookie');
require('./carousel');
require('./googlemaps');
// require('./slide-to-section');
// require('./smooth-scroll');
// require('./visible');
// require('./sendmail');
require('lightgallery');
require('lightgallery/modules/lg-thumbnail.min.js');
require('lightgallery/modules/lg-autoplay.min.js');
require('lightgallery/modules/lg-fullscreen.min.js');
require('lightgallery/modules/lg-share.min.js');
require('lightgallery/modules/lg-zoom.min.js');
require('lightgallery/modules/lg-video.min.js');

$(document).ready(function() {

    $("#lightgallery").lightGallery({ selector: '.gallery-item' });

    $(".scroll-to-top").click(function(){
        $('html,body').animate({ scrollTop: 0 }, 'slow');
        return false;
    });

    $('#officesTab a[data-toggle="tab"]').on('show.bs.tab', function(e) {
        let target = $(e.target).data('second-target');
        $("#officeFloorplansContent, #officeFloorplansSelector")
            .children('.tab-pane.active')
            .removeClass('active show');

        $(target)
            .addClass('active show')
    });

    $(".floor-selector").on('click', function(e){
        let targetIndex = $(e.target).data('target');
        let targeBuilding = $(this).data('target');
        if(targetIndex !== undefined) {
            $(this).children().removeClass('selected');
            $(e.target).addClass('selected');
            $(targeBuilding + ' .office-tab li:nth-child('+ targetIndex +') .nav-link').tab('show')
        }
    });
    $('.office-tab').on('click', function(e){
        let floorTarget = $(e.target).parent('.nav-item').index();
        let floorSelectorElement = $(".floor-selector");
        if(floorTarget >= 0 && $(".floor-selector").parents('.tab-pane.fade.active.show').length){
            floorSelectorElement
                .parents('.tab-pane.fade.active.show')
                .find('.selected')
                .removeClass('selected');
            floorSelectorElement
                .parents('.tab-pane.fade.active.show')
                .find(`[data-target='${floorTarget + 1}']`)
                .addClass('selected');
        }
    });
    // onScroll();
    // $(document).on("load", onScroll);
    // $(document).on("scroll", onScroll);

    $(".video-modal-opener").on('click touch', function(e) {
        const videoURL 	    = $(this).data('video-url');
        let video = $(`<iframe preload controls autoplay class="w-100" height="" src type="video/mp4" allow="autoplay"></iframe>`)
            .attr('src', videoURL+"&autoplay=1;start=0")
            .attr('height', $(this).height());
        $(this).html(video);
    });

    $(".play-video-btn").on('click touch', function(e) {
        $(".video-modal-opener").first().click();
    });
});


function onScroll(event) {
    const element = $('h2 span');
    element.each(function(i, elem) {
        if ($(elem).visible(true)) {
            var windowHeight = window.innerHeight;
            let width =  100 - ($(elem).offset().top - $(window).scrollTop()) / windowHeight * 100;
            elem.style.setProperty('--width', width * 1.5 + 'vw');
        }
    });
}
